import { ItemRoutesProps } from "./PageRoute";
import { Route } from "react-router-dom";
import { findUserPremission } from "../../Pages/Users/Roles/UserSecurityFind";
import { SettingsSections } from "../../Services/SettingService";
import DashboardTemplate from "../../Template/DashboardTemplate";
import AddJournal from "../../Pages/Journals/AddJournal";
import { IPermissionActionType } from "../../Pages/Users/Roles/UserPermissionCommonData";
import { ITypeIIsClientSpecificRoleDataType } from "../../../Context/RoleContext";
import ResourceNotFound from "../ResourceNotFound";
import JournalsTable from "../../Pages/Journals/JournalsTable";

const JournalRoute = ({
  currentClient,
  clientSpecificRole,
}: ItemRoutesProps) => {
  return (
    <>
      {/* ----------- Journals Route ----------- */}
      <Route
        path={`${currentClient?.id}/journals`}
        element={
          findUserPremission(
            ["Voucher.Journal.12.View"],
            clientSpecificRole(),
            currentClient?.id!,
            [SettingsSections.Journal],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<JournalsTable />}
              breadcrumprops={[
                {
                  item: "Journals",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />

      <Route
        path={`${currentClient?.id}/journals/add`}
        element={
          findUserPremission(
            ["Voucher.Journal.12.Add"],
            clientSpecificRole(),
            currentClient?.id!,
            [SettingsSections.Journal],
            {
              actionType: IPermissionActionType.Add,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddJournal />}
              breadcrumprops={[
                {
                  item: "Journals",
                  path: `/billing/clients/${currentClient?.id}/journals`,
                },
                {
                  item: "Add",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />

      <Route
        path={`${currentClient?.id}/journals/editDraft/:draftId`}
        element={
          findUserPremission(
            ["Voucher.Journal.12.Edit"],
            clientSpecificRole(),
            currentClient?.id!,
            [SettingsSections.Journal],
            {
              actionType: IPermissionActionType.Edit,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddJournal />}
              breadcrumprops={[
                {
                  item: "Journals",
                  path: `/billing/clients/${currentClient?.id}/journals`,
                },
                {
                  item: "Draft",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />

      <Route
        path={`${currentClient?.id}/journals/:journalId`}
        element={
          findUserPremission(
            ["Voucher.Journal.12.Edit"],
            clientSpecificRole(),
            currentClient?.id!,
            [SettingsSections.Journal],
            {
              actionType: IPermissionActionType.Edit,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddJournal />}
              breadcrumprops={[
                {
                  item: "Journals",
                  path: `/billing/clients/${currentClient?.id}/journals`,
                },
                {
                  item: "Edit",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
    </>
  );
};

export default JournalRoute;
